import { useInfiniteQuery } from "@tanstack/react-query";
import { tableService } from "../services/tableService";
import { TableParams } from "../services/tableService/table";
import { useState, useEffect } from "react";
import { useToast } from "../../view/components/ui/use-toast";

export const useTable = (initialParams?: TableParams) => {
  const [params, setParams] = useState<TableParams>(initialParams || {});

  const handleTableData = async ({ pageParam = 0 }) => {
    const response = await tableService.table({
      ...params,
      skip: pageParam,
      limit: 99,
    });

    return response;
  };

  const {
    data,
    fetchNextPage,
    hasNextPage,
    isLoading,
    isFetching,
    isError,
    isFetchingNextPage,
  } = useInfiniteQuery({
    queryKey: ["allTables", params],
    queryFn: handleTableData,
    getNextPageParam: (lastPage) => {
      if (
        lastPage.pagination.skip + lastPage.pagination.limit ===
        lastPage.pagination.total / lastPage.pagination.limit
      ) {
        return null;
      }
      return lastPage.pagination.skip + lastPage.pagination.limit;
    },
    initialPageParam: undefined,
  });

  const { toast } = useToast();

  useEffect(() => {
    if (isError) {
      toast({
        variant: "destructive",
        title: "Erro ao carregador os dados, tente novamente mais tarde!",
      });
    }
  }, [isError, toast]);

  return {
    isLoading,
    isFetching,
    data,
    params,
    setParams,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  };
};
